import React, { useState, useEffect, useRef } from "react";
import { Grid, CardMedia, Typography } from "@mui/material";
import { MediaPlayer, MediaProvider, Poster } from "@vidstack/react";
import {  defaultLayoutIcons,  DefaultVideoLayout} from "@vidstack/react/player/layouts/default";
import "react-image-gallery/styles/css/image-gallery.css";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
// import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TheatersIcon from '@mui/icons-material/Theaters';
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
// import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import Tooltip from "@mui/material/Tooltip";
import CenterMode from "../utilities/centerModeSlider";
import CenterModeVideo from "../utilities/centerModeVideoSlider";
// import CenterModePdf from "../../components/utilities/centerModePdfSlider";
import { Box,  useMediaQuery } from "@mui/system";
import CenterModeReelVideo from "../utilities/centerModeReelVideo";
// icons
import workFLowImg from '../../assets/landing-page/images/Flow_Medical_Blue_1.png';
import preProducationImg from '../../assets/landing-page/images/pre_producation.jpg';
import producationImg from '../../assets/landing-page/images/producation.png';
import sinusitisImg from '../../assets/landing-page/images/sinusitis_img_landing_page.png';
import idea from '../../assets/landing-page/images/idea.png';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// import DownloadPDF from "../../assets/utahlegal/Animation Process.pdf";
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchRef,
} from "react-zoom-pan-pinch";

// import {
//     ReactZoomPanPinchRef,
//   } from "react-zoom-pan-pinch";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/HomePage.scss";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import '@vidstack/react/player/styles/default/layouts/audio.css';
// import "./index.scss";
import "../../styles/new_design.scss";
const UPLOAD_MYVIDEO__URL = import.meta.env.VITE_UPLOAD_MYVIDEO__URL;

// for videos
interface VideoData {
  id: number;
  src: string;
  title: string;
  poster: string;
}
// for reels
interface ReelsData {
  id: number;
  src: string;
  title: string;
  poster: string;
}
// for images
interface ImagesData {
  id: number;
  src: string;
  name: string;
}
// For Pdfs
interface PdfData {
  id: number;
  src: string;
  poster: string;
  title: string;
}

interface categoryView{
  category: string;
}

interface ControlsProps {
  zoomIn: () => any;
  zoomOut: () => any;
  resetTransform: () => any;
}

const Controls: React.FC<ControlsProps> = ({
  zoomIn,
  zoomOut,
  resetTransform,
}) => (
  <Box
    sx={{
      textAlign: "end",
      position: "absolute",
      top: "10px",
      left: "0",
      right: "0",
      zIndex: "9",
    }}
  >
    <ZoomInIcon
      fontSize="medium"
      onClick={() => zoomIn()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
    <ZoomOutIcon
      fontSize="medium"
      onClick={() => zoomOut()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
    <CenterFocusStrongIcon
      fontSize="medium"
      onClick={() => resetTransform()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
  </Box>
);

const CustomAnimationDesign: React.FC<categoryView> = (category) => {
  //Getting json after use this interface
  interface AllData {
    images: ImagesData[];
    reels: ReelsData[];
    videos: VideoData[];
    pdf: PdfData[];
    // Add other properties of your spineJson2 as needed
  }
  const [dataJson, setDataJson] = useState<AllData | null>(null);
  const [showImageSlider, setShowImageSlider] = useState<boolean>(false);
  const [showReels, setShowReels] = useState<boolean>(false);
  const [showVideoSlider, setShowVideoSlider] = useState<boolean>(false);
  const [showPdfContent, setShowPdfContent] = useState<boolean>(false);
  const transformComponentRef = useRef<ReactZoomPanPinchRef | null>(null);
  // const [currentActImage, setActImage] = useState<Number>(0);

  const sliderRef = useRef<Slider | null>(null); // Reference for the slider
  const imageRefs = useRef<(HTMLDivElement | null)[]>([]);
  const reelsRefs = useRef<(HTMLDivElement | null)[]>([]);
  const videoRefs = useRef<(HTMLDivElement | null)[]>([]);
  const pdfRefs = useRef<(HTMLDivElement | null)[]>([]);

  const [selectedReel, setSelectedReels] = useState<number>(0); // Track selected image ID
  const [selectedImage, setSelectedImage] = useState<number>(0); // Track selected image ID
  const [selectedVideo, setSelectedVideo] = useState<number>(0);
  const [selectedPdf, setSelectedPdf] = useState<number>(0);
  const isMobile = useMediaQuery("(max-width:820px)");

  //Getting Data from json Using URL Pathname
  useEffect(() => {
    // Fetch data from the provided URL
    const fetchData = async () => {
      try {
        // Get the pathname from window location
        // const pathKey = window.location.pathname.replace("/", "");
        const pathKey = category?.category.toLowerCase();
        // console.log("PathKey", category.category);
        const response = await fetch(
          `${UPLOAD_MYVIDEO__URL}medical/customMain.json`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // console.log(response);
        const data = await response.json();
        // setSpineData(data[pathKey]);
        // Check if the pathKey exists in data and is in correct format
        if (data[pathKey] && Array.isArray(data[pathKey])) {
          const firstItem = data[pathKey][0];
          // console.log(data[pathKey]);
          // console.log(firstItem);
          // Ensure the data conforms to the SpineData structure
          const structuredData: AllData = {
            images: firstItem.images || [],
            reels: firstItem.reels || [],
            videos: firstItem.videos || [],
            pdf: firstItem.pdf || [],
          };
          const firstObject = Object.keys(firstItem)[1];
          if (firstObject == "images") {
            setShowImageSlider(true);
          } else if (firstObject == "videos") {
            setShowVideoSlider(true);
          } else if (firstObject == "reels") {
            setShowReels(true);
          } else {
            setShowPdfContent(true);
          }
          setDataJson(structuredData);
        } else {
          console.log(
            "No matching data for this pathname or data is not in correct format."
          );
        }
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      }
    };
    fetchData();
  }, []);

  // Initialize spineImages, spineVideos, and spinePDFs only if spineJson is not null
  // const spineImages2 :ReelsData[]= spineJson2?.images || [];
  // const spineVideos2 : VideoData[] = spineJson2?.videos || [];
  // const spinePDFs2 : spinePdf[] = spineJson2?.pdf || [];

  const images: ImagesData[] = dataJson?.images || [];
  const reels: ReelsData[] = dataJson?.reels || [];
  const videos: VideoData[] = dataJson?.videos || [];
  const pDFs: PdfData[] = dataJson?.pdf || [];

  //  Image Smooth Scroll
  useEffect(() => {
    if (imageRefs.current[selectedImage]) {
      imageRefs.current[selectedImage].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedImage]);

  // Videos Scroll
  useEffect(() => {
    if (videoRefs.current[selectedVideo]) {
      videoRefs.current[selectedVideo].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedVideo]);
  // reels Scroll
  useEffect(() => {
    if (reelsRefs.current[selectedReel]) {
      reelsRefs.current[selectedReel].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedReel]);
  // pdf Scroll
  useEffect(() => {
    if (pdfRefs.current[selectedPdf]) {
      pdfRefs.current[selectedPdf].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedPdf]);

  // Handle image click and navigate to that image in the slider
  const handleImageClick = (imageIndex: number) => {
    setSelectedImage(imageIndex);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(imageIndex); // Jump to the clicked image's slide
    }
  };
  // Image Slider settings
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    ref: (slider: any) => (sliderRef.current = slider),
  };
  // Pdf Settings
  //   const pdfSettings = {
  //     infinite: false,
  //     speed: 500,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     ref: (slider: any) => (sliderRef.current = slider),
  //   };

  // Videos Click function
  const handleVideoClick = (videoIndex: number) => {
    setSelectedVideo(videoIndex);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(videoIndex); // Navigate to the selected video
    }
  };

  // Reels Click Function
  const handleVideoClick2 = (videoIndex: number) => {
    setSelectedReels(videoIndex);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(videoIndex); // Navigate to the selected video
    }
  };

  // Pdf Click Function

  //   const handlePdfClick = (pdfIndex: number) => {
  //     setSelectedPdf(pdfIndex);
  //     if (sliderRef.current) {
  //       sliderRef.current.slickGoTo(pdfIndex); // Navigate to the selected video
  //     }
  //   };

  // video section
  // useEffect(() => {
  //   const handleNextButtonClick = () => {};
  //   const nextButton = document.querySelector(".slick-arrow.slick-next");
  //   if (nextButton) {
  //     nextButton.addEventListener("click", handleNextButtonClick);
  //   }
  //   return () => {
  //     if (nextButton) {
  //       nextButton.removeEventListener("click", handleNextButtonClick);
  //     }
  //   };
  // }, [showVideoSlider]);

  // useEffect(() => {
  //   const handlePrevButtonClick = () => {};
  //   const prevButton = document.querySelector(".slick-arrow.slick-prev");
  //   if (prevButton) {
  //     prevButton.addEventListener("click", handlePrevButtonClick);
  //   }
  //   return () => {
  //     if (prevButton) {
  //       prevButton.removeEventListener("click", handlePrevButtonClick);
  //     }
  //   };
  // }, [showVideoSlider]);

  // Videos click to highlight secion

  const totalVideos = videos.length;
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (showVideoSlider) {
        const currentIndex: number = Number(selectedVideo);

        if (event.keyCode === 39) {
          // Right arrow key
          if (sliderRef.current) {
            if (currentIndex === totalVideos - 1) {
              sliderRef.current.slickGoTo(0);
              setSelectedVideo(0);
            } else {
              sliderRef.current.slickNext();
              setSelectedVideo(currentIndex + 1);
            }
          }
        } else if (event.keyCode === 37) {
          // Left arrow key
          if (sliderRef.current) {
            if (currentIndex === 0) {
              sliderRef.current.slickGoTo(totalVideos - 1);
              setSelectedVideo(totalVideos - 1);
            } else {
              sliderRef.current.slickPrev();
              setSelectedVideo(currentIndex - 1);
            }
          }
        }
      }
    };

    const handleClickNext = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedVideo);
        if (currentIndex === totalVideos - 1) {
          sliderRef.current.slickGoTo(0);
          setSelectedVideo(0);
        } else {
          sliderRef.current.slickNext();
          setSelectedVideo(currentIndex + 1);
        }
      }
    };

    const handleClickPrev = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedVideo);
        if (currentIndex === 0) {
          sliderRef.current.slickGoTo(totalVideos - 1);
          setSelectedVideo(totalVideos - 1);
        } else {
          sliderRef.current.slickPrev();
          setSelectedVideo(currentIndex - 1);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    const nextButton = document.querySelector(".slick-arrow.slick-next");
    const prevButton = document.querySelector(".slick-arrow.slick-prev");

    if (nextButton) {
      nextButton.addEventListener("click", handleClickNext);
    }

    if (prevButton) {
      prevButton.addEventListener("click", handleClickPrev);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (nextButton) {
        nextButton.removeEventListener("click", handleClickNext);
      }
      if (prevButton) {
        prevButton.removeEventListener("click", handleClickPrev);
      }
    };
  }, [showVideoSlider, selectedVideo, totalVideos]);

  // Images click to highlight secion
  const totalImages = images.length;
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (showImageSlider) {
        if (event.keyCode === 39) {
          // Right arrow key
          if (sliderRef.current) {
            //  currentIndex = selectedImage;
            let currentIndex: number = Number(selectedImage);

            if (currentIndex === totalImages - 1) {
              // If at the last image, go to the first
              sliderRef.current.slickGoTo(0);
              setSelectedImage(0);
            } else {
              sliderRef.current.slickNext();
              setSelectedImage(currentIndex + 1);
            }
          }
        } else if (event.keyCode === 37) {
          // Left arrow key
          if (sliderRef.current) {
            // const currentIndex = selectedImage;
            let currentIndex: number = Number(selectedImage);

            if (currentIndex === 0) {
              // If at the first image, go to the last
              sliderRef.current.slickGoTo(totalImages - 1);
              setSelectedImage(totalImages - 1);
            } else {
              sliderRef.current.slickPrev();
              setSelectedImage(currentIndex - 1);
            }
          }
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showImageSlider, selectedImage, totalImages]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (showImageSlider) {
        const currentIndex: number = Number(selectedImage);

        if (event.keyCode === 39) {
          // Right arrow key
          if (sliderRef.current) {
            if (currentIndex === totalImages - 1) {
              sliderRef.current.slickGoTo(0);
              setSelectedImage(0);
            } else {
              sliderRef.current.slickNext();
              setSelectedImage(currentIndex + 1);
            }
          }
        } else if (event.keyCode === 37) {
          // Left arrow key
          if (sliderRef.current) {
            if (currentIndex === 0) {
              sliderRef.current.slickGoTo(totalImages - 1);
              setSelectedImage(totalImages - 1);
            } else {
              sliderRef.current.slickPrev();
              setSelectedImage(currentIndex - 1);
            }
          }
        }
      }
    };

    const handleClickNext = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedImage);
        if (currentIndex === totalImages - 1) {
          sliderRef.current.slickGoTo(0);
          setSelectedImage(0);
        } else {
          sliderRef.current.slickNext();
          setSelectedImage(currentIndex + 1);
        }
      }
    };

    const handleClickPrev = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedImage);
        if (currentIndex === 0) {
          sliderRef.current.slickGoTo(totalImages - 1);
          setSelectedImage(totalImages - 1);
        } else {
          sliderRef.current.slickPrev();
          setSelectedImage(currentIndex - 1);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    const nextButton = document.querySelector(".slick-arrow.slick-next");
    const prevButton = document.querySelector(".slick-arrow.slick-prev");

    if (nextButton) {
      nextButton.addEventListener("click", handleClickNext);
    }

    if (prevButton) {
      prevButton.addEventListener("click", handleClickPrev);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (nextButton) {
        nextButton.removeEventListener("click", handleClickNext);
      }
      if (prevButton) {
        prevButton.removeEventListener("click", handleClickPrev);
      }
    };
  }, [showImageSlider, selectedImage, totalImages]);

  const totalPdf = pDFs.length;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (showPdfContent) {
        const currentIndex: number = Number(selectedPdf);

        if (event.keyCode === 39) {
          // Right arrow key
          if (sliderRef.current) {
            if (currentIndex === totalPdf - 1) {
              sliderRef.current.slickGoTo(0);
              setSelectedPdf(0);
            } else {
              sliderRef.current.slickNext();
              setSelectedPdf(currentIndex + 1);
            }
          }
        } else if (event.keyCode === 37) {
          // Left arrow key
          if (sliderRef.current) {
            if (currentIndex === 0) {
              sliderRef.current.slickGoTo(totalPdf - 1);
              setSelectedPdf(totalPdf - 1);
            } else {
              sliderRef.current.slickPrev();
              setSelectedPdf(currentIndex - 1);
            }
          }
        }
      }
    };

    const handleClickNext = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedPdf);
        if (currentIndex === totalPdf - 1) {
          sliderRef.current.slickGoTo(0);
          setSelectedPdf(0);
        } else {
          sliderRef.current.slickNext();
          setSelectedPdf(currentIndex + 1);
        }
      }
    };

    const handleClickPrev = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedPdf);
        if (currentIndex === 0) {
          sliderRef.current.slickGoTo(totalPdf - 1);
          setSelectedPdf(totalPdf - 1);
        } else {
          sliderRef.current.slickPrev();
          setSelectedPdf(currentIndex - 1);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    const nextButton = document.querySelector(".slick-arrow.slick-next");
    const prevButton = document.querySelector(".slick-arrow.slick-prev");

    if (nextButton) {
      nextButton.addEventListener("click", handleClickNext);
    }

    if (prevButton) {
      prevButton.addEventListener("click", handleClickPrev);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (nextButton) {
        nextButton.removeEventListener("click", handleClickNext);
      }
      if (prevButton) {
        prevButton.removeEventListener("click", handleClickPrev);
      }
    };
  }, [showPdfContent, selectedPdf, totalPdf]);

  // useEffect(() => {
  //   const handleKeyDown = (event: KeyboardEvent) => {
  //     if (showImageSlider) {
  //       if (event.keyCode === 39) {
  //         const nextButton = document.querySelector(
  //           ".slick-arrow.slick-next"
  //         ) as HTMLElement;
  //         if (nextButton) {
  //           nextButton.click();
  //         }
  //       } else if (event.keyCode === 37) {
  //         const prevButton = document.querySelector(
  //           ".slick-arrow.slick-prev"
  //         ) as HTMLElement;
  //         if (prevButton) {
  //           prevButton.click();
  //         }
  //       }
  //     }
  //     console.log(sliderRef);
  //   };
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [showImageSlider]);

  // Horizontal Click Icons Function
  // Image icon Function
  const handleImgCardClick = () => {
    setShowImageSlider(true);
    setShowReels(false);
    setShowVideoSlider(false);
    setShowPdfContent(false);
  };
  // Reel icon Function
  const handleReelClick = () => {
    setShowImageSlider(false);
    setShowReels(true);
    setShowVideoSlider(false);
    setShowPdfContent(false);
  };
  // Video icon Function
  const handleVidCardClick = () => {
    setShowImageSlider(false);
    setShowReels(false);
    setShowVideoSlider(true);
    setShowPdfContent(false);
  };
  // Pdf icon Function
  const handlePdfButtonClick = () => {
    setShowImageSlider(false);
    setShowReels(false);
    setShowVideoSlider(false);
    setShowPdfContent(true);
  };
  // Video Settings
  const settings2 = {
    className: "videogallery",
    dots: false,
    arrows: false,
    autoplay: false,
    infinite: false,
    fade: true,
    speed: 10,
    adaptiveHeight: true,
    swipe: true,
    draggable: false,
    ref: (slider: any) => (sliderRef.current = slider),
    afterChange: (index: number) => {
      const container = document.querySelectorAll(".carouselvideo");
      container.forEach((carousel, i) => {
        const allPlayers = carousel.querySelector("video") as HTMLVideoElement;
        if (i !== index) {
          allPlayers.pause();
        } else {
          allPlayers.play();
        }
      });
    },
  };

  return (
    <Grid className="approot new_design">
      <Grid container sx={{}} className="contentMain">
        <Grid
          container
          item
          spacing={-8}
          // spacing={!isMobile ? -8 : 0}
          marginLeft={0}
          xs={12}
          md={1}
          lg={1}
          sm={12}
          className="buttonPanel"
          pr={2}
          sx={{
            flexDirection: {
              xs: "row",
              md: "column",
            },
            justifyContent: {
              xs: "space-around",
              md: "center",
            },

            marginTop: {
              xs: 0,
              md: 0,
            },
          }}
        >
          <Box
            letterSpacing={1}
            sx={{
              flexDirection: {
                xs: "row", // horizontal on mobile
                md: "column", // vertical on larger screens
              },
              display: "flex", // Ensure flexbox layout
              justifyContent: "center", // Optional: Center content horizontally
              alignItems: "center", // Optional: Align items to the center
              gap: { xs: 2, md: 0 }, // Optional: Adjust spacing between items
            }}
          >
            {reels.length > 0 && (
              <Box marginBottom={{ xs: 0, md: 2 }} marginTop={{ xs: 0, md: 2 }}>
                <Tooltip title="Reels" placement="right-start" arrow>
                  <TheatersIcon
                    className="displayCategory"
                    fontSize="large"
                    onClick={handleReelClick}
                    sx={{
                      backgroundColor: showReels ? "transparent" : "",
                      color: showReels ? "#fff" : "#8d8d8d",
                      borderRadius: showReels ? "5px" : "",
                      width: showReels ? "50px" : "40px",
                    }}
                  />
                </Tooltip>
              </Box>
            )}
            {videos.length > 0 && (
              <Box marginBottom={{ xs: 0, md: 2 }} marginTop={{ xs: 0, md: 2 }}>
                <Tooltip title="Video" placement="right-start" arrow>
                  <VideocamRoundedIcon
                    fontSize="large"
                    className="displayCategory"
                    onClick={handleVidCardClick}
                    sx={{
                      backgroundColor: showVideoSlider ? "transparent" : "",
                      color: showVideoSlider ? "#fff" : "#8d8d8d",
                      borderRadius: showVideoSlider ? "5px" : "",
                      width: showVideoSlider ? "50px" : "40px",
                    }}
                  />
                </Tooltip>
              </Box>
            )}

            {images.length > 0 && (
              <Box marginBottom={{ xs: 0, md: 2 }} marginTop={{ xs: 0, md: 2 }}>
                <Tooltip title="Images" placement="right-start" arrow>
                  <CameraAltIcon
                    className="displayCategory"
                    onClick={handleImgCardClick}
                    sx={{
                      backgroundColor: showImageSlider ? "transparent" : "",
                      borderRadius: showImageSlider ? "5px" : "",
                      color: showImageSlider ? "#fff" : "#8d8d8d",
                      width: showImageSlider ? "50px" : "40px",
                      fontSize: showImageSlider ? "large" : "small",
                    }}
                  />
                </Tooltip>
              </Box>
            )}
            {pDFs.length > 0 && (
              <Box marginBottom={{ xs: 0, md: 2 }} marginTop={{ xs: 0, md: 2 }}>
                <Tooltip title="Workflow" placement="right-start" arrow>
                  <DescriptionOutlinedIcon
                    fontSize="large"
                    className="displayCategory"
                    onClick={handlePdfButtonClick}
                    sx={{
                      backgroundColor: showPdfContent ? "transparent" : "",
                      color: showPdfContent ? "#fff" : "#8d8d8d",
                      borderRadius: showPdfContent ? "5px" : "",
                      width: showPdfContent ? "50px" : "40px",
                    }}
                  />
                </Tooltip>
              </Box>
            )}
          </Box>
        </Grid>
        {/* Images Section Start */}
        {showImageSlider && (
          <Grid
            className="design_back"
            container
            item
            marginLeft={3}
            mt={4}
            xs={12}
            md={11}
            sm={12}
          >
            {/* Horizontal Slider */}
            <Grid
              // container
              item
              marginLeft={3}
              marginRight={4}
              xs={12}
              md={2}
              lg={2}
              sm={12}
              className="horizontal_section"
              sx={{
                height: "85vh",
                overflowY: "auto",
                // flexDirection: {
                //   xs: "row",
                //   md: "column",
                // },
                display: {
                  xs: "contents",
                  md: "flex",
                },
                paddingTop: 0,
                marginTop: 1,
              }}
            >
              {showImageSlider && !isMobile && (
                <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{
                    flexDirection: {
                      xs: "row",
                      md: "column",
                    },
                    display: {
                      xs: "contents",
                      md: "flex",
                    },
                  }}
                >
                  {images.map((image, index) => (
                    <div
                      key={image.id}
                      ref={(el) => (imageRefs.current[index] = el)} // Store the ref for each image
                      onClick={() => handleImageClick(index)} // Handle click event
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardMedia
                          component="img"
                          image={UPLOAD_MYVIDEO__URL + image.src}
                          alt={`Image ${image.id}`}
                          width={"100%"}
                          sx={{
                            // width: "100%",
                            aspectRatio: "1.3 / 1",
                            objectFit: "cover",
                            marginBottom: "1%",
                            cursor: "pointer",
                            filter:
                              selectedImage === index
                                ? "brightness(50%)"
                                : "none",
                            borderRadius:
                              selectedImage === index ? "15px" : "none",
                          }}
                        />
                        {/* <ArrowForwardIosOutlinedIcon
                        className="active_img"
                        sx={{ marginLeft: '5px', color: '#1976d2' }}
                      /> */}
                        {selectedImage === index && (
                          <ArrowForwardIosOutlinedIcon
                            className="active_img"
                            sx={{ marginLeft: "5px", color: "#1976d2" }}
                          />
                        )}
                      </Box>
                      {image.name && (
                        <Typography
                          className="name"
                          sx={{
                            marginBottom: "12%",
                            textAlign: "center",
                            marginTop: "5px",
                            fontWeight: "600",
                          }}
                        >
                          {/* {image.name} */}

                          {image.name.length <= 15
                            ? image.name
                            : image.name.substr(0, 15) + "..."}
                        </Typography>
                      )}
                      {!image.name && <br></br>}
                    </div>
                  ))}
                </Grid>
              )}
              {showImageSlider && isMobile && (
                <CenterMode
                  images={images}
                  selectedImage={selectedImage}
                  handleImageClick={handleImageClick}
                />
              )}
            </Grid>
            <Grid
              item
              marginLeft={4}
              marginRight={4}
              mt={0}
              xs={12}
              md={8}
              lg={9}
              sm={12}
              className="img_view_section"
            >
              {showImageSlider && (
                <Grid>
                  <Slider {...sliderSettings}>
                    {images.map((image) => (
                      <Box
                        key={image.id}
                        sx={{
                          border: "solid 1px",
                          borderRadius: "8px",
                          position: "relative",
                        }}
                      >
                        <TransformWrapper
                          initialScale={1}
                          ref={transformComponentRef}
                        >
                          {(utils) => (
                            <React.Fragment>
                              <Controls {...utils} />
                              <TransformComponent>
                                <img
                                  src={UPLOAD_MYVIDEO__URL + image.src}
                                  alt={`Image ${image.id}`}
                                  id={`imgExample${image.id}`}
                                  style={{ width: "100%", height: "auto" }}
                                />
                              </TransformComponent>
                            </React.Fragment>
                          )}
                        </TransformWrapper>
                      </Box>
                    ))}
                  </Slider>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {/* Image Section End */}

        {/* Reels Section Starts */}
        {showReels && (
          <Grid
            className="design_back"
            container
            item
            marginLeft={3}
            mt={4}
            xs={12}
            md={11}
            sm={12}
          >
            {/* Horizontal Slider */}
            <Grid
              // container
              item
              marginLeft={3}
              marginRight={4}
              xs={12}
              md={2}
              lg={2}
              sm={12}
              className="horizontal_section"
              sx={{
                height: "85vh",
                overflowY: "auto",
                // flexDirection: {
                //   xs: "row",
                //   md: "column",
                // },
                display: {
                  xs: "contents",
                  md: "flex",
                },
                paddingTop: 0,
                marginTop: 1,
              }}
            >
              {showReels && !isMobile && (
                <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{
                    flexDirection: {
                      xs: "row",
                      md: "column",
                    },
                    display: {
                      xs: "contents",
                      md: "flex",
                    },
                  }}
                >
                  {reels.map((video, index) => (
                    <div
                      key={video.id}
                      ref={(el) => (reelsRefs.current[index] = el)} // Store the ref for each image
                      onClick={() => handleVideoClick2(index)} // Handle click event
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardMedia
                          key={video.id}
                          sx={{
                            width: "100%",
                            aspectRatio: "1.3/ 1",
                            objectFit: "fill !important",
                            marginBottom: "12%",
                            filter:
                              selectedReel === index
                                ? "brightness(50%)"
                                : "none",
                            borderRadius:
                              selectedReel === index ? "15px" : "none",
                          }}
                          component="img"
                          className="vid_sec"
                          // onClick={() => handleVideoClick(index)}
                          image={video.poster}
                          alt="Image"
                        />
                        {selectedReel === index && (
                          <ArrowForwardIosOutlinedIcon
                            className="active_img"
                            sx={{ marginLeft: "5px", color: "#1976d2" }}
                          />
                        )}
                      </Box>
                      <Typography
                        className="name"
                        sx={{
                          marginBottom: "12%",
                          textAlign: "center",
                          marginTop: "5px",
                          fontWeight: "600",
                        }}
                      >
                        {/* {video.title} */}
                        {video.title.length <= 15
                          ? video.title
                          : video.title.substr(0, 15) + "..."}
                      </Typography>
                    </div>
                  ))}
                </Grid>
              )}
              {showReels && isMobile && (
                <CenterModeReelVideo
                  videos={reels}
                  selectedReel={selectedReel}
                  handleVideoClick2={handleVideoClick2}
                />
              )}
            </Grid>
            <Grid
              item
              marginLeft={4}
              marginRight={4}
              mt={0}
              xs={12}
              md={8}
              lg={9}
              sm={12}
              className="img_view_section"
            >
              {showReels && (
                <Grid>
                  <Slider {...settings2} className="videogallery">
                    {reels.map((video: VideoData) => (
                      <MediaPlayer
                        key={video.id}
                        id={`videoslider${video.id}`}
                        className="carouselvideo"
                        src={UPLOAD_MYVIDEO__URL + video.src}
                        viewType="video"
                        streamType="on-demand"
                        logLevel="warn"
                        crossOrigin
                        playsInline
                        title={video.title}
                        poster={video.poster}
                        // controls
                        // muted
                        // onClick={(e) => {
                        //   const videoElement = e.currentTarget as HTMLVideoElement;
                        //   if (videoElement.paused) {
                        //     videoElement.play();
                        //   } else {
                        //     videoElement.pause();
                        //   }
                        // }}
                      >
                        <MediaProvider>
                          <Poster className="vds-poster" />
                        </MediaProvider>
                        <DefaultVideoLayout icons={defaultLayoutIcons} />
                      </MediaPlayer>
                      // <MediaPlayer src="https://files.vidstack.io/sprite-fight/hls/stream.m3u8" >
                      //   <MediaProvider>
                      //     <Poster className="vds-poster" />
                      //   </MediaProvider>
                      //   <DefaultVideoLayout icons={defaultLayoutIcons} />
                      // </MediaPlayer>
                    ))}
                  </Slider>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}

        {/* Videos Section Starts */}
        {showVideoSlider && (
          <Grid
            className="design_back"
            container
            item
            marginLeft={3}
            mt={4}
            xs={12}
            md={11}
            sm={12}
          >
            {/* Horizontal Slider */}
            <Grid
              // container
              item
              marginLeft={3}
              marginRight={4}
              xs={12}
              md={2}
              lg={2}
              sm={12}
              className="horizontal_section"
              sx={{
                height: "85vh",
                overflowY: "auto",
                // flexDirection: {
                //   xs: "row",
                //   md: "column",
                // },
                display: {
                  xs: "contents",
                  md: "flex",
                },
                paddingTop: 0,
                marginTop: 1,
              }}
            >
              {showVideoSlider && !isMobile && (
                <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{
                    flexDirection: {
                      xs: "row",
                      md: "column",
                    },
                    display: {
                      xs: "contents",
                      md: "flex",
                    },
                  }}
                >
                  {videos.map((video, index) => (
                    <div
                      key={video.id}
                      ref={(el) => (videoRefs.current[index] = el)} // Store the ref for each image
                      onClick={() => handleVideoClick(index)} // Handle click event
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardMedia
                          key={video.id}
                          sx={{
                            width: "100%",
                            aspectRatio: "1.3/ 1",
                            objectFit: "fill !important",
                            marginBottom: "12%",
                            filter:
                              selectedVideo === index
                                ? "brightness(50%)"
                                : "none",
                            borderRadius:
                              selectedVideo === index ? "15px" : "none",
                          }}
                          component="img"
                          className="vid_sec"
                          // onClick={() => handleVideoClick(index)}
                          image={UPLOAD_MYVIDEO__URL + video.poster}
                          alt="Image"
                        />
                        {selectedVideo === index && (
                          <ArrowForwardIosOutlinedIcon
                            className="active_img"
                            sx={{ marginLeft: "5px", color: "#1976d2" }}
                          />
                        )}
                      </Box>
                      <Typography
                        className="name"
                        sx={{
                          marginBottom: "12%",
                          textAlign: "center",
                          marginTop: "5px",
                          fontWeight: "600",
                        }}
                      >
                        {/* {video.title} */}
                        {video.title.length <= 15
                          ? video.title
                          : video.title.substr(0, 15) + "..."}
                      </Typography>
                    </div>
                  ))}
                </Grid>
              )}
              {showVideoSlider && isMobile && (
                <CenterModeVideo
                  videos={videos}
                  selectedvideos={selectedVideo}
                  handleVideoClick={handleVideoClick}
                />
              )}
            </Grid>
            <Grid
              item
              marginLeft={4}
              marginRight={4}
              mt={0}
              xs={12}
              md={8}
              lg={9}
              sm={12}
              className="img_view_section"
            >
              {showVideoSlider && (
                <Grid>
                  <Slider {...settings2} className="videogallery">
                    {/* {videos.map((video: VideoData) => ( */}
                    {videos[selectedVideo] && (
                      // <MediaPlayer
                      //   key={video.id}
                      //   id={`videoslider${video.id}`}
                      //   className="carouselvideo"
                      //   src={video.src}
                      //   viewType="video"
                      //   streamType="on-demand"
                      //   logLevel="warn"
                      //   crossOrigin
                      //   playsInline
                      //   title={video.title}
                      //   poster={video.poster}
                      //   // controls
                      // >
                      //   <MediaProvider>
                      //     <Poster className="vds-poster" />
                      //   </MediaProvider>
                      //   <DefaultVideoLayout icons={defaultLayoutIcons} />
                      // </MediaPlayer>
                      // <MediaPlayer src="../src/assets/54SparkPlugRemovalAVAU/hls.m3u8" >
                      //   <MediaProvider>
                      //     <Poster className="vds-poster" />
                      //   </MediaProvider>
                      //   <DefaultVideoLayout icons={defaultLayoutIcons} />
                      // </MediaPlayer>
                      <MediaPlayer
                        key={videos[selectedVideo].id}
                        id={`videoslider${videos[selectedVideo].id}`}
                        className="carouselvideo"
                        // src='../../assets/54SparkPlugRemovalAVAU/hls.m3u8'
                        src={UPLOAD_MYVIDEO__URL + videos[selectedVideo].src}
                        viewType="video"
                        streamType="on-demand"
                        logLevel="warn"
                        crossOrigin
                        playsInline
                        title={videos[selectedVideo].title}
                        poster={
                          UPLOAD_MYVIDEO__URL + videos[selectedVideo].poster
                        }
                      >
                        <MediaProvider>
                          <Poster className="vds-poster" />
                          {/* {textTracks.map(track => (
                          <Track {...track} key={track.src} />
                        ))} */}
                        </MediaProvider>
                        <DefaultVideoLayout icons={defaultLayoutIcons} />
                      </MediaPlayer>
                    )}
                  </Slider>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {/* Videos Section End */}

        {/* Pdf Section Starts */}
        {showPdfContent && (
          <Box
            className="design_back pdf_cont"
            // container
            // item
            //  marginLeft={3}
            //     mt={4}
            //     xs={12}
            //     md={12}
            //     sm={12}
            // //  sx={{ ml: 3, mt: 4 }} // Use 'sx' for styles
            //     sx={{ ml: 3, mt: 4}}
          >
            <Box className="img_view_section">
              <Typography variant="h4" className="pdf_title_1">
                Our 3D Animation Workflow
              </Typography>
              <Typography variant="h5" className="pdf_title_2">
                Creating a custom animation that captures and communicates the
                message and story you want the viewer to receive and understand
                is easier than you think.{" "}
              </Typography>
              <Grid container>
                <Grid
                  item
                  md={3}
                  sm={12}
                  xs={12}
                  sx={{ alignContent: "center" }}
                  className="idea"
                >
                  <Box
                    sx={{
                      maxHeight: "65%",
                      display: "block",
                      margin: "0 auto",
                    }}
                    component="img"
                    src={idea}
                    alt="idea"
                  />
                </Grid>
                <Grid item md={9} sm={12} xs={12}>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      It all begins in Pre-Production; where we lay the
                      foundation for a stunning animation
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Our pre-production phase is where the magic begins! This
                      is the time for brainstorming ideas, crafting detailed
                      storyboards, and shaping the overall concept that drives
                      the animation. We dive deep into defining the story,
                      creating intricate 3D models, and establishing the perfect
                      setting and style that resonates with your audience.
                    </Typography>
                  </Box>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Crafting the Script: Accuracy Meets Engaging Content
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Once we've fine-tuned your concept together, it's time to
                      bring it to life with a well-crafted script. Our
                      experienced team collaborates closely with your team and
                      with our own in-house medical professionals to ensure
                      everything we communicate is accurate and easy to
                      understand. We work together to ensure the draft script
                      sounds professional yet remains accessible for patients.
                      This script acts as a detailed blueprint, outlining
                      dialogue, voiceovers, actions, and scenes—setting the
                      stage for a captivating production.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      display: "block",
                      margin: "0 auto",
                    }}
                    component="img"
                    src={workFLowImg}
                    alt="workFLowImg"
                  />
                </Grid>
                <Grid
                  item
                  md={4}
                  sm={12}
                  xs={12}
                  sx={{ alignContent: "center" }}
                >
                  <Box
                    sx={{
                      display: "block",
                      margin: "0 auto",
                    }}
                    component="img"
                    src={preProducationImg}
                    alt="preProducationImg"
                  />
                </Grid>
                <Grid item md={8} sm={12} xs={12}>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Storyboarding and Animation Planning: Visualizing the
                      Story
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Storyboarding is a crucial step where we transform our
                      script into a visual narrative. Here, we sketch each scene
                      or compile references to give a clear sense of how the
                      animation will flow. Whether in video format, if models
                      are ready, or still images in documents, storyboarding
                      provides a structured overview that guides our creative
                      journey.
                    </Typography>
                  </Box>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Voice Recording: Bringing Characters to Life with Sound
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      If your animation includes dialogue or voiceovers, we kick
                      off the voice recording process early. We generate AI
                      voiceovers for reference, ensuring that the right tone and
                      emotion are captured as we build your project. We can also
                      use talented voice actors to record the final lines,
                      keeping your audio in sync and ready for seamless
                      integration with the animation.
                    </Typography>
                  </Box>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Animatics: A Preview of the Final Product
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Next up are animatics, where we create rough, simplified
                      versions of your animation using storyboard images and
                      recorded dialogue. This step helps us visualize timing and
                      pacing without diving into detailed animation, allowing us
                      to fine-tune everything before fully committing our
                      creative resources.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item md={8} sm={12} xs={12}>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      The next step is Production; where we bring ideas to life
                      <br></br>
                      Modeling, Staging, and Rigging: Crafting a Digital World
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      In this exciting phase, we bring your characters,
                      environments, products and services to life through 3D
                      modeling. Our skilled artists utilize cutting-edge
                      software to sculpt and rig models, ensuring everything is
                      accurate with guidance from our medical experts. This
                      meticulous attention to detail lays the groundwork for
                      stunning animations.
                    </Typography>
                  </Box>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Texturing and Shading: Adding Depth and Realism
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Texturing and shading follow, adding color and surface
                      detail while mastering how light interacts with our
                      models. This process adds necessary depth and realism,
                      making our animation truly captivating.
                    </Typography>
                  </Box>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Animation: Infusing Life and Emotion
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Animators breathe life into static models, this is the
                      stage where characters come alive, accompanied by
                      perfectly timed camera movements as envisioned in your
                      storyboards and animatics.
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  sm={12}
                  xs={12}
                  sx={{ alignContent: "center" }}
                >
                  <Box
                    sx={{
                      display: "block",
                      margin: "0 auto",
                      padding: "15px",
                    }}
                    component="img"
                    src={producationImg}
                    alt="producationImg"
                  />
                </Grid>
                <Grid
                  item
                  md={4}
                  sm={12}
                  xs={12}
                  sx={{ alignContent: "center" }}
                >
                  <Box
                    sx={{
                      display: "block",
                      margin: "0 auto",
                      padding: "15px",
                    }}
                    component="img"
                    src={sinusitisImg}
                    alt="sinusitisImg"
                  />
                </Grid>
                <Grid item md={8} sm={12} xs={12}>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Lighting: Setting the Scene
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Next, our lighting artists sprinkle a bit of magic,
                      illuminating your 3D environment with virtual lights. By
                      adjusting the intensity, color, and direction, they create
                      the mood that enhances the storytelling experience.
                    </Typography>
                  </Box>

                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Finally there’s Post-Production: these are the finishing
                      touches<br></br>
                      Rendering: Creating the Final Masterpiece
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      With all elements in place, rendering transforms our 3D
                      scenes into stunning final images. This process calculates
                      lighting, shadows, and textures, resulting in high-quality
                      frames ready for action. Rendering work is handled by our
                      in-house advanced systems.
                    </Typography>
                  </Box>

                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Compositing, Editing, and Sound: The Final Flourishes
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      In this vibrant stage, we merge rendered images with 2D
                      elements—backgrounds, effects, and more. Our compositors
                      adjust colors, add visual effects, and perfect the overall
                      aesthetics to create an engaging final product.
                    </Typography>
                  </Box>
                  <Box className="content_head">
                    <Typography variant="h5" className="pdf_title">
                      Review and Revision: Perfecting the Final Cut
                    </Typography>
                    <Typography variant="h6" className="pdf_content">
                      Throughout your animation production, we prioritize
                      collaboration, inviting feedback from your team and
                      medical experts. This ensures that every detail is
                      perfect, resulting in a polished final animation that
                      exceeds expectations.
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};
export default CustomAnimationDesign;
